/**
 * Custom eSputnik events which are not sent by the Shopify Yespo app.
 * Product IDs are Shopify product IDs, matching the IDs the app sends in
 * web-tracking and which must also be used in the product feed.
 */
(() => {
  const recentEvents = new Map();

  function getProductId(element) {
    if (!element) return null;

    const productElement = element.closest(
      '[data-product-id], [data-productid], [data-product_id]'
    );
    const data = element.dataset || {};
    const productData = productElement ? productElement.dataset : {};

    return (
      data.productId ||
      data.productid ||
      data.product_id ||
      productData.productId ||
      productData.productid ||
      productData.product_id ||
      null
    );
  }

  function sendAddToWishlist(productId) {
    if (!productId || typeof window.eS !== 'function') return;

    const id = String(productId);
    const now = Date.now();
    if (recentEvents.get(id) && now - recentEvents.get(id) < 1000) return;

    recentEvents.set(id, now);
    window.eS('send', 'event', 'AddToWishlist', { product_id: id });
  }

  // Public helper for a wishlist app or a custom button integration.
  window.unicoTrackAddToWishlist = sendAddToWishlist;

  document.addEventListener('click', (event) => {
    const button = event.target.closest(
      '[data-wishlist-button], [data-wishlist-add], [data-action="add-to-wishlist"], [data-wishlist-action="add"], .wishlist-button, .wishlist-btn, .swym-add-to-wishlist'
    );
    if (button) sendAddToWishlist(getProductId(button));
  });

  // Supports integrations that expose a semantic browser event instead of a button.
  ['unico:wishlist-added', 'wishlist:added'].forEach((eventName) => {
    document.addEventListener(eventName, (event) => {
      const productId = event.detail && (event.detail.productId || event.detail.product_id);
      sendAddToWishlist(productId || getProductId(event.target));
    });
  });
})();
